import { render } from "./LatestNews.vue?vue&type=template&id=a2ce5a0c&scoped=true&ts=true"
import script from "./LatestNews.ts?vue&type=script&lang=ts"
export * from "./LatestNews.ts?vue&type=script&lang=ts"

import "./LatestNews.scss?vue&type=style&index=0&id=a2ce5a0c&lang=scss&scoped=true"

import exportComponent from "/Users/koenverbruggen/Sites/02-SITES/nederlandsmijnmuseum.local/wp-content/themes/nmm/js/vue/nmm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ce5a0c"]])

export default __exports__